import React, { useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import NaviBarv2_En from "./Components/NaviBarv2_En";
import Footer_En from "./Components/Footer_En";
import { Container, Row, Col, Card, Badge, Button, Form, Alert } from "react-bootstrap";

const ACCENT = "#198754";

const numStyle = (branch) => ({
  width: 34,
  height: 34,
  borderRadius: "50%",
  background: branch ? "#b5720c" : ACCENT,
  color: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 14,
  marginBottom: 10,
});

const EZ_STEPS = [
  {
    n: 1,
    deadline: "15 business days ahead",
    title: "Fill out",
    text: "the author's certificate form (see the generator below)",
  },
  {
    n: 2,
    title: "Send to the CISPT",
    text:
      "materials in Word, an abstract in Russian (if the material is in a foreign language), a scan of the signed certificate — to the CISPT email evseeva.ev@talantiuspeh.ru",
  },
  {
    n: 3,
    title: "Deliver",
    text: "printed materials and the original certificate — 3rd floor, office М15",
  },
  {
    n: 4,
    title: "Examination",
    text: "signing of the ER by members of the Commission (KVEK)",
  },
  {
    n: 5,
    branch: true,
    title: "In case of disagreement",
    text: "the materials are referred to an external review",
  },
  {
    n: 6,
    title: "Approval of the ER",
    text:
      "the CISPT sends a scan of the ER to the author by email; the original is collected in office М15",
  },
];

// Значения option-ов должны оставаться на русском — авторская справка формируется на русском.
const PURPOSE_DETAIL_LABEL = {
  журнал: "Journal name",
  конференция: "Conference name",
  диссовет: "Dissertation council name",
  иное: "Purpose details",
};

const PURPOSE_TEXT = {
  журнал: "опубликования в журнале",
  конференция: "опубликования в сборнике тезисов конференции",
  диссовет: "представления к защите в диссертационный совет",
  иное: "представления",
};

const MONTHS = [
  "января", "февраля", "марта", "апреля", "мая", "июня",
  "июля", "августа", "сентября", "октября", "ноября", "декабря",
];

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])
  );
}

function fill(value, placeholder) {
  if (value && value !== "") {
    return '<span class="ez-fill">' + escapeHtml(value) + "</span>";
  }
  return '<span class="ez-empty">' + escapeHtml(placeholder) + "</span>";
}

// Печать/сохранение в PDF через скрытый iframe (без всплывающего окна — не
// блокируется, работает быстрее). @page { margin: 0 } убирает служебные
// колонтитулы браузера (дата, about:blank, номер страницы); отступы задаются
// через padding у body.
function printHtml(content) {
  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  document.body.appendChild(iframe);

  const frameWin = iframe.contentWindow;
  const frameDoc = frameWin.document;
  frameDoc.open();
  frameDoc.write(
    '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Авторская справка</title><style>' +
      "@page{size:A4;margin:0;}" +
      "*{margin:0;padding:0;box-sizing:border-box;}" +
      'body{font-family:Georgia,"Times New Roman",serif;font-size:14px;line-height:1.8;color:#1a1a1a;padding:1.5cm 2cm;background:#fff;}' +
      ".ez-title{text-align:center;font-weight:700;font-size:16px;margin-bottom:20px;}" +
      "p{margin:0 0 14px 0;text-align:justify;}" +
      ".ez-sign-line{display:flex;justify-content:space-between;margin-top:15px;}" +
      ".ez-sign-label{font-size:11px;color:#777;margin-top:2px;}" +
      ".ez-fill{border-bottom:1px solid #666;padding:0 4px;font-weight:500;}" +
      ".ez-empty{border-bottom:1px solid #999;padding:0 4px;color:#b8382f;}" +
      "</style></head><body>" +
      content +
      "</body></html>"
  );
  frameDoc.close();

  // Chrome берёт имя файла для «Сохранить как PDF» из document.title верхней
  // страницы (даже при печати iframe). На время печати подменяем заголовок,
  // затем возвращаем прежний.
  const prevTitle = document.title;
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    document.title = prevTitle;
    window.removeEventListener("afterprint", finish);
    if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
  };

  const runPrint = () => {
    document.title = "Авторская справка";
    window.addEventListener("afterprint", finish);
    frameWin.onafterprint = finish;
    frameWin.focus();
    frameWin.print();
    // Подстраховка, если браузер не пришлёт afterprint.
    setTimeout(finish, 60000);
  };

  if (frameDoc.readyState === "complete") {
    setTimeout(runPrint, 100);
  } else {
    frameWin.onload = () => setTimeout(runPrint, 100);
  }
}

// Ленивая подгрузка библиотеки docx (UMD) с CDN — только при первом клике по
// «Download .docx». Библиотека кладёт себя в window.docx.
let docxLibPromise = null;
function ensureDocx() {
  if (window.docx) return Promise.resolve(window.docx);
  if (docxLibPromise) return docxLibPromise;
  docxLibPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://cdn.jsdelivr.net/npm/docx@8.5.0/build/index.umd.js";
    s.async = true;
    s.onload = () =>
      window.docx ? resolve(window.docx) : reject(new Error("docx недоступен"));
    s.onerror = () => {
      docxLibPromise = null;
      reject(new Error("Не удалось загрузить библиотеку docx"));
    };
    document.head.appendChild(s);
  });
  return docxLibPromise;
}

function ExpertReview_En() {
  const [fio, setFio] = useState("");
  const [isStudent, setIsStudent] = useState(false);
  const [supervisorFio, setSupervisorFio] = useState("");
  const [materialType, setMaterialType] = useState("статьи");
  const [pages, setPages] = useState("");
  const [titleRu, setTitleRu] = useState("");
  const [isForeign, setIsForeign] = useState(false);
  const [titleEn, setTitleEn] = useState("");
  const [purposeType, setPurposeType] = useState("журнал");
  const [purposeDetail, setPurposeDetail] = useState("");
  const [publisher, setPublisher] = useState("");
  const [signDate, setSignDate] = useState("");
  const [docHtml, setDocHtml] = useState("");

  const docRef = useRef(null);

  // Авторская справка — официальный документ Университета «Сириус», формируется
  // на русском. deriveFields() общий для предпросмотра и .docx.
  function deriveFields() {
    let titleText = titleRu ? "«" + titleRu + "»" : "";
    if (isForeign && titleEn) {
      titleText += " (" + titleEn + ")";
    }
    const fullMaterial = [materialType, titleText].filter(Boolean).join(" ");

    const purposeText = PURPOSE_TEXT[purposeType] || "";
    let fullPurpose = purposeText;
    if (purposeDetail) fullPurpose += " " + purposeDetail;
    if (purposeType === "журнал" && publisher) {
      fullPurpose += " (издательство: " + publisher + ")";
    }

    let dateStr = "";
    if (signDate) {
      const d = new Date(signDate + "T00:00:00");
      if (!isNaN(d.getTime())) {
        dateStr =
          d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear() + " г.";
      }
    }
    return { fullMaterial, fullPurpose, dateStr };
  }

  function buildDoc() {
    const { fullMaterial, fullPurpose, dateStr } = deriveFields();

    let html = '<div class="ez-title">Авторская справка</div>';
    html +=
      "<p>Я, " +
      fill(fio, "Ф.И.О. автора") +
      ", автор " +
      fill(fullMaterial, "вид и название материалов") +
      "</p>";
    html +=
      "<p>в количестве " +
      fill(pages, "__") +
      " листов, подтверждаю, что в представленных материалах, предназначенных для " +
      fill(
        fullPurpose,
        "опубликования в журнале (указать название журнала и название издательства), сборнике тезисов/материалов конференции (указать полное название конференции), представления к защите в диссертационный совет и т.п."
      ) +
      "</p>";
    html +=
      "<p>не содержится сведений, составляющих государственную тайну, служебную или коммерческую тайну, препятствующих открытой публикации.</p>";
    html +=
      "<p>Сообщаю, что мне известно о персональной ответственности автора за разглашение сведений, составляющих государственную тайну, подлежащих защите законами РФ о защите объектов интеллектуальной собственности.</p>";
    html +=
      "<p>В предлагаемом к опубликованию тексте нет данных по незащищённым объектам интеллектуальной собственности других авторов.</p>";
    html +=
      "<p>Согласен на использование результатов своей работы безвозмездно в АНОО ВО «Университет «Сириус»» для учебного процесса.</p>";

    html += '<div style="margin-top:25px;">';
    html +=
      '<div class="ez-sign-line"><div>Автор ____________________ ' +
      fill(fio, "Ф.И.О.") +
      "</div></div>";

    if (isStudent) {
      html +=
        '<div class="ez-sign-line" style="margin-top:18px;"><div>Научный руководитель ____________________ ' +
        fill(supervisorFio, "Ф.И.О. руководителя") +
        "</div></div>";
    }

    html +=
      '<p style="margin-top:20px;">«' +
      (dateStr || '<span class="ez-empty">дата не указана</span>') +
      "»</p>";
    html += "</div>";

    return html;
  }

  function generate() {
    setDocHtml(buildDoc());
  }

  function printDoc() {
    if (!docHtml) {
      alert("Please generate the certificate first!");
      return;
    }
    printHtml(docRef.current ? docRef.current.innerHTML : docHtml);
  }

  function copyText() {
    if (!docHtml || !docRef.current) {
      alert("Please generate the certificate first!");
      return;
    }
    const clone = docRef.current.cloneNode(true);
    clone.querySelectorAll(".ez-empty").forEach((el) => {
      el.textContent = "__________";
    });
    const finalText = clone.innerText.trim();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(finalText)
        .then(() => alert("Text copied!"))
        .catch(() => fallbackCopy(finalText));
    } else {
      fallbackCopy(finalText);
    }
  }

  function fallbackCopy(text) {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
    alert("Text copied!");
  }

  // Формирование и скачивание реального .docx (Times New Roman 14pt, 1.5
  // интервал, по ширине). Содержимое справки — на русском (официальная форма).
  async function downloadDocx() {
    let lib;
    try {
      lib = await ensureDocx();
    } catch (e) {
      alert("Failed to load the .docx library");
      return;
    }
    const { Document, Packer, Paragraph, TextRun, AlignmentType } = lib;
    const { fullMaterial, fullPurpose, dateStr } = deriveFields();

    const fontProps = { font: "Times New Roman", size: 28 };
    const LONG = "________________________________________________________";
    const NAME = "_______________________";
    const empty = () => new Paragraph({ children: [] });
    const body = (text) =>
      new Paragraph({
        children: [new TextRun({ text, ...fontProps })],
        alignment: AlignmentType.JUSTIFIED,
        spacing: { line: 360 },
      });

    const children = [
      new Paragraph({
        alignment: AlignmentType.CENTER,
        children: [
          new TextRun({
            text: "Авторская справка",
            bold: true,
            size: 28,
            font: "Times New Roman",
          }),
        ],
        spacing: { after: 200 },
      }),
      empty(),
      body("Я, " + (fio || NAME) + ", автор " + (fullMaterial || LONG)),
      body(
        "в количестве " +
          (pages || "___") +
          " листов, подтверждаю, что в представленных материалах, предназначенных для " +
          (fullPurpose || LONG)
      ),
      body(
        "не содержится сведений, составляющих государственную тайну, служебную или коммерческую тайну, препятствующих открытой публикации."
      ),
      empty(),
      body(
        "Сообщаю, что мне известно о персональной ответственности автора за разглашение сведений, составляющих государственную тайну, подлежащих защите законами РФ о защите объектов интеллектуальной собственности."
      ),
      body(
        "В предлагаемом к опубликованию тексте нет данных по незащищённым объектам интеллектуальной собственности других авторов."
      ),
      body(
        "Согласен на использование результатов своей работы безвозмездно в АНОО ВО «Университет «Сириус»» для учебного процесса."
      ),
      empty(),
      new Paragraph({
        children: [
          new TextRun({
            text: "Автор  ______________________________  " + (fio || NAME),
            ...fontProps,
          }),
        ],
        alignment: AlignmentType.LEFT,
        spacing: { before: 600, after: 200, line: 360 },
      }),
      ...(isStudent
        ? [
            new Paragraph({
              children: [
                new TextRun({
                  text:
                    "Научный руководитель  ______________________________  " +
                    (supervisorFio || NAME),
                  ...fontProps,
                }),
              ],
              alignment: AlignmentType.LEFT,
              spacing: { before: 400, after: 100, line: 360 },
            }),
          ]
        : []),
      new Paragraph({
        children: [
          new TextRun({ text: "«" + (dateStr || "___") + "»", ...fontProps }),
        ],
        alignment: AlignmentType.LEFT,
        spacing: { before: 400, line: 360 },
      }),
    ];

    const doc = new Document({
      styles: {
        default: {
          document: {
            run: fontProps,
            paragraph: {
              spacing: { line: 360 },
              alignment: AlignmentType.JUSTIFIED,
            },
          },
        },
      },
      sections: [
        {
          properties: {
            page: {
              margin: { top: 1000, bottom: 1000, left: 1500, right: 1500 },
            },
          },
          children,
        },
      ],
    });

    Packer.toBlob(doc)
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Авторская_справка.docx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to create the .docx file");
      });
  }

  return (
    <div className="App">
      <NaviBarv2_En />

      <style>{`
        .ez-doc {
          background: #fffefb;
          border: 1px solid #ccc;
          padding: 35px 30px;
          min-height: 480px;
          font-family: Georgia, "Times New Roman", serif;
          font-size: 14px;
          line-height: 1.8;
          color: #1a1a1a;
        }
        .ez-doc .ez-title { text-align: center; font-weight: 700; font-size: 16px; margin-bottom: 20px; }
        .ez-doc p { margin: 0 0 14px 0; text-align: justify; }
        .ez-doc .ez-fill { border-bottom: 1px solid #666; padding: 0 4px; font-weight: 500; }
        .ez-doc .ez-empty { border-bottom: 1px solid #999; padding: 0 4px; color: #b8382f; }
        .ez-doc .ez-sign-line { display: flex; justify-content: space-between; margin-top: 15px; }
        .ez-doc .ez-sign-label { font-size: 11px; color: #777; margin-top: 2px; }
        .ez-doc-empty { color: #999; font-style: italic; text-align: center; padding: 60px 0; }
      `}</style>

      <Container className="py-4 text-start">
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-2">Expert Review (ER)</h1>
          <p className="text-muted mb-2">
            Sirius University — examination of materials intended for open
            publication, and an author's certificate generator
          </p>
          <Badge bg="success" className="fs-6 px-3 py-2">
            Expert Review (ER)
          </Badge>
        </div>

        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            Obtaining the expert review
          </h2>
          <Row className="g-3">
            {EZ_STEPS.map((s) => (
              <Col key={s.n} md={6} lg={4}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body>
                    {s.deadline && (
                      <div
                        className="small text-uppercase mb-1"
                        style={{ color: "#b5720c", letterSpacing: "0.06em" }}
                      >
                        {s.deadline}
                      </div>
                    )}
                    <div style={numStyle(s.branch)}>{s.n}</div>
                    <h3 className="h6 fw-bold">{s.title}</h3>
                    <p className="text-muted small mb-0">{s.text}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        <section className="mb-5">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h3 className="h5 fw-bold" style={{ color: ACCENT }}>
                Important to remember
              </h3>
              <ul className="text-muted mb-0">
                <li>
                  The type of material (article / theses / presentation material)
                  is stated in the certificate.
                </li>
                <li>The title must match in the certificate and in the materials themselves.</li>
                <li>
                  For material in a foreign language — the certificate states the
                  title in the foreign and Russian languages, with an abstract /
                  theses in Russian attached.
                </li>
                <li>
                  If the authors are students only, the certificate is signed by
                  the student and their academic supervisor.
                </li>
                <li>
                  If the materials were substantially changed after the ER was
                  prepared — a repeat examination is required.
                </li>
              </ul>
            </Card.Body>
          </Card>
        </section>

        <section className="mb-4">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            Author's certificate generator
          </h2>
          <Alert variant="light" className="border small text-muted mb-4">
            The generated certificate («Авторская справка») is produced in
            Russian — it is the official form submitted to Sirius University.
          </Alert>
          <Row className="g-4">
            <Col lg={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body>
                  <h3
                    className="h5 fw-bold mb-3 pb-2"
                    style={{ borderBottom: `2px solid ${ACCENT}` }}
                  >
                    Fill in all fields
                  </h3>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold small">
                      Author's full name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ivanov Ivan Ivanovich"
                      value={fio}
                      onChange={(e) => setFio(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="ez-en-isStudent"
                    label="The author is a student"
                    checked={isStudent}
                    onChange={(e) => setIsStudent(e.target.checked)}
                  />

                  {isStudent && (
                    <Form.Group
                      className="mb-3 ps-3"
                      style={{ borderLeft: `3px solid ${ACCENT}` }}
                    >
                      <Form.Label className="fw-semibold small">
                        Academic supervisor's full name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Petrov Petr Petrovich"
                        value={supervisorFio}
                        onChange={(e) => setSupervisorFio(e.target.value)}
                      />
                    </Form.Group>
                  )}

                  <Row>
                    <Col xs={7}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold small">
                          Material type
                        </Form.Label>
                        <Form.Select
                          value={materialType}
                          onChange={(e) => setMaterialType(e.target.value)}
                        >
                          <option value="статьи">Article</option>
                          <option value="тезисов">Theses</option>
                          <option value="презентационного материала">
                            Presentation material
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={5}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold small">
                          Pages
                        </Form.Label>
                        <Form.Control
                          type="number"
                          min="1"
                          placeholder="12"
                          value={pages}
                          onChange={(e) => setPages(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold small">
                      Material title (in Russian)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Название"
                      value={titleRu}
                      onChange={(e) => setTitleRu(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="ez-en-isForeign"
                    label="Foreign-language material / translation"
                    checked={isForeign}
                    onChange={(e) => setIsForeign(e.target.checked)}
                  />

                  {isForeign && (
                    <Form.Group
                      className="mb-3 ps-3"
                      style={{ borderLeft: `3px solid ${ACCENT}` }}
                    >
                      <Form.Label className="fw-semibold small">
                        Title in the foreign language / translation
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Title in English"
                        value={titleEn}
                        onChange={(e) => setTitleEn(e.target.value)}
                      />
                    </Form.Group>
                  )}

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold small">Purpose</Form.Label>
                    <Form.Select
                      value={purposeType}
                      onChange={(e) => setPurposeType(e.target.value)}
                    >
                      <option value="журнал">Publication in a journal</option>
                      <option value="конференция">Conference proceedings</option>
                      <option value="диссовет">Dissertation council</option>
                      <option value="иное">Other</option>
                    </Form.Select>
                  </Form.Group>

                  {purposeType === "журнал" ? (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold small">
                          Journal name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Journal name"
                          value={purposeDetail}
                          onChange={(e) => setPurposeDetail(e.target.value)}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold small">
                          Publisher name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Publisher"
                          value={publisher}
                          onChange={(e) => setPublisher(e.target.value)}
                        />
                      </Form.Group>
                    </>
                  ) : (
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold small">
                        {PURPOSE_DETAIL_LABEL[purposeType]}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Details"
                        value={purposeDetail}
                        onChange={(e) => setPurposeDetail(e.target.value)}
                      />
                    </Form.Group>
                  )}

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold small">
                      Signing date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={signDate}
                      onChange={(e) => setSignDate(e.target.value)}
                    />
                  </Form.Group>

                  <Button variant="success" className="w-100 fw-bold" onClick={generate}>
                    📄 Generate certificate
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body>
                  <h3
                    className="h5 fw-bold mb-3 pb-2"
                    style={{ borderBottom: `2px solid ${ACCENT}` }}
                  >
                    Generated certificate
                  </h3>
                  {docHtml ? (
                    <div
                      className="ez-doc"
                      ref={docRef}
                      dangerouslySetInnerHTML={{ __html: docHtml }}
                    />
                  ) : (
                    <div className="ez-doc">
                      <div className="ez-doc-empty">
                        Fill in the fields on the left and click
                        <br />
                        <strong>«Generate certificate»</strong>
                      </div>
                    </div>
                  )}
                  <div className="d-flex flex-wrap gap-2 mt-3">
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={copyText}
                    >
                      📋 Copy text
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={printDoc}
                    >
                      🖨️ Print / PDF
                    </Button>
                    <Button
                      size="sm"
                      onClick={downloadDocx}
                      style={{
                        backgroundColor: "#1b2a4a",
                        borderColor: "#1b2a4a",
                        color: "#fff",
                      }}
                    >
                      ⬇️ Download .docx
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </section>
      </Container>

      <Footer_En />
    </div>
  );
}

export default ExpertReview_En;
